// ===== Helper Functions =====
function wv_getCookie(name) {
  const m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return m ? m[2] : null;
}

function wv_setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

// ===== WV ZIP List =====
const wvZipList = [
  24701,24712,24714,24715,24716,24719,24724,24726,24731,24733,24736,24738,24740,
  24801,24808,24811,24813,24815,24816,24817,24818,24820,24821,24822,24823,24825,
  24901,24910,24915,24916,24918,24920,24925,24927,24931,24934,24935,24938,24941,
  25003,25005,25015,25019,25021,25024,25028,25030,25033,25035,25036,25039,25044,
  25101,25102,25106,25107,25108,25109,25110,25111,25112,25114,25115,25118,25119,
  25201,25202,25203,25204,25208,25209,25211,25213,25214,25231,25234,25235,25239,
  25301,25302,25303,25304,25305,25309,25311,25312,25313,25314,25315,25320,25387,
  25401,25403,25404,25405,25410,25411,25413,25414,25419,25420,25425,25427,25428,
  25501,25502,25503,25504,25505,25510,25511,25512,25514,25515,25520,25521,25523,
  25601,25606,25607,25608,25617,25621,25624,25625,25628,25630,25632,25634,25635,
  25701,25702,25703,25704,25705,25706,25707,25708,25709,25710,25711,25712,25713,
  25801,25802,25812,25813,25817,25818,25820,25823,25825,25826,25827,25831,25832,
  25901,25902,25904,25905,25907,25908,25915,25916,25917,25918,25919,25920,25936,
  26003,26030,26031,26032,26033,26034,26035,26036,26037,26038,26039,
  26101,26102,26103,26104,26105,26133,26134,26136,26137,26138,26141,26142,
  26201,26202,26203,26205,26206,26208,26209,26210,26215,26217,26218,26219,
  26301,26302,26321,26323,26325,26327,26328,26330,26332,26335,26337,26338,
  26405,26408,26410,26411,26412,26416,26419,26422,26424,26425,26426,26428,
  26501,26502,26504,26505,26506,26507,26508,26519,26520,26521,26524,26525,
  26601,26610,26611,26612,26613,26614,26615,26617,26618,26619,
  26704,26705,26707,26710,26711,26714,26716,26717,26719,26720,
  26801,26802,26804,26807,26808,26810,26812,26814,26815,26817,26818,26823,26833,26836,26838,26847,26851,26852,26865,26886
];

// ===== Main Logic =====
document.addEventListener("DOMContentLoaded", () => {

  // Skip popup if WV IP detected by Liquid in theme.liquid
  if (window.wvSkipPopup === true) return;

  // Skip popup if override cookie exists
  if (wv_getCookie("wv_override") === "true") return;

  // Show popup
  const overlay = document.getElementById("wv-zip-popup-overlay");
  overlay.style.display = "flex";

  document.getElementById("wv-zip-submit").addEventListener("click", () => {
    const zip = parseInt(document.getElementById("wv-zip-input").value.trim());
    const error = document.getElementById("wv-zip-error");

    if (wvZipList.includes(zip)) {
      wv_setCookie("wv_override", "true", 365);
      overlay.style.display = "none";
      location.reload();
    } else {
      error.style.display = "block";
    }
  });

  document.getElementById("wv-zip-close").addEventListener("click", () => {
    overlay.style.display = "none";
  });

});
